import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import {useTranslation} from '@wix/yoshi-flow-editor'
import classNames from 'classnames'
import React from 'react'
import {useAppActions, useAppSelector} from '../../../../hooks/runtime'
import {getCalendarLinks} from '../../../../selectors/calendar-links'
import {AddToCalendar} from './add-to-calendar'
import {DownloadPapyrusTickets} from './download-papyrus-tickets'
import {SuccessActionsProps} from './interfaces'
import s from './success-actions.scss'

const getButtonClasses = (primary = true) => classNames(s.actionButton, primary ? s.primary : s.secondary)

export const SuccessActions = ({
  className = '',
  calendarButtonText,
  downloadTicketsVisible,
  addToCalendarVisible,
}: SuccessActionsProps) => {
  const {t} = useTranslation()
  const {addToCalendarClicked, addToCalendarOptionClicked} = useAppActions()

  const calendarLinks = useAppSelector(getCalendarLinks)

  return !downloadTicketsVisible && !addToCalendarVisible ? null : (
    <div className={className}>
      {downloadTicketsVisible && (
        <DownloadPapyrusTickets className={classNames(getButtonClasses(), s.primaryActionMargin)} />
      )}
      {addToCalendarVisible && (
        <AddToCalendar
          dataHook={DH.ADD_TO_CALENDAR}
          className={getButtonClasses(!downloadTicketsVisible)}
          buttonText={calendarButtonText || t('ticketsThankYou.addToCalendar')}
          calendarLinks={calendarLinks}
          onClick={addToCalendarClicked}
          onOptionClick={addToCalendarOptionClicked}
        />
      )}
    </div>
  )
}
